import { createContext } from "react";
import { Row } from "react-table";

export default createContext<Row<any>[]>([]);
